export default __webpack_public_path__ + "static/media/sbp.a5b40faf.svg";